import { environment } from './../environments/environment';
import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.clientId,
    authority: 'https://login.microsoftonline.com/6ee19001-d0c4-45f8-af8b-ff00f16d07e1', //Cemex
    // authority: 'https://login.microsoftonline.com/b4040842-9e9f-4300-98f3-c13fe1a67fd2', //Neoris
    redirectUri: '/'
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }
}

export const protectedResources = {
  client: {
    endpoint: `${environment.urlBaseService}Client`,
    scopes: [environment.urlScope]
  },
  vehicle: {
    endpoint: `${environment.urlBaseService}TransportUnit`,
    scopes: [environment.urlScope]
  },
  security: {
    endpoint: `${environment.urlBaseService}Security`,
    scopes: [environment.urlScope]
  },
  realtime: {
    endpoint: `${environment.urlBaseService}RealTimeDashboard`,
    scopes: [environment.urlScope]
  },
  general: {
    endpoint: `${environment.urlBaseService}PBITokenInfo`,
    scopes: [environment.urlScope]
  },
  userAdministration: {
    endpoint: `${environment.urlBaseService}userAdministration`,
    scopes: [environment.urlScope]
  },
  realTimesTrucktDetail: {
    endpoint: `${environment.urlBaseService}RealTimesTrucktDetail`,
    scopes: [environment.urlScope]
  },
  realTimeTrucksByCheckpoint: {
    endpoint: `${environment.urlBaseService}RealTimeTrucksByCheckpoint`,
    scopes: [environment.urlScope]
  },
  TotalCountry: {
    endpoint: `${environment.urlBaseService}TotalCountry`,
    scopes: [environment.urlScope]
  },
  sourceDeviceStatus: {
    endpoint: `${environment.urlBaseService}SourceDevicesStatus`,
    scopes: [environment.urlScope]
  },
  Incidents:{
    endpoint: `${environment.urlBaseService}v1/incident/incidents`,
    scopes: [environment.urlScope]
  },
  Sites:{
    endpoint: `${environment.urlBaseService}v1/incident/sites"`,
    scopes: [environment.urlScope]
  },
  incidentsTypes:{
    endpoint: `${environment.urlBaseService}v1/incident/incident-types"`,
    scopes: [environment.urlScope]
  },
  incidentsStatus:{
    endpoint: `${environment.urlBaseService}v1/incident/incident-status"`,
    scopes: [environment.urlScope]
  }
  
}

export const loginRequest = {
  scopes: []
};
